module.exports = __webpack_public_path__ + "img/COMPRAS-INDIRETAS-thumb.77edcc0d.png";